var map = {
	"./": 312,
	"./UserSettings": 1155,
	"./UserSettings.dictionary": 346,
	"./UserSettings.dictionary.json": 346,
	"./UserSettings.tsx": 1155,
	"./UserSettingsDeferred": 379,
	"./UserSettingsDeferred.tsx": 379,
	"./components/ChangeButton": 859,
	"./components/ChangeButton/": 859,
	"./components/ChangeButton/ChangeButton.module.scss": 937,
	"./components/ChangeButton/index": 859,
	"./components/ChangeButton/index.tsx": 859,
	"./components/SettingToggler": 916,
	"./components/SettingToggler/": 916,
	"./components/SettingToggler/SettingToggler.module.scss": 1051,
	"./components/SettingToggler/index": 916,
	"./components/SettingToggler/index.tsx": 916,
	"./components/SettingsLoader": 935,
	"./components/SettingsLoader/": 935,
	"./components/SettingsLoader/index": 935,
	"./components/SettingsLoader/index.tsx": 935,
	"./components/SettingsSection": 833,
	"./components/SettingsSection/": 833,
	"./components/SettingsSection/SettingsSection.module.scss": 850,
	"./components/SettingsSection/index": 833,
	"./components/SettingsSection/index.tsx": 833,
	"./components/ThemeSetting": 986,
	"./components/ThemeSetting/": 986,
	"./components/ThemeSetting/ThemeSetting": 987,
	"./components/ThemeSetting/ThemeSetting.dictionary": 934,
	"./components/ThemeSetting/ThemeSetting.dictionary.json": 934,
	"./components/ThemeSetting/ThemeSetting.explanation": 1156,
	"./components/ThemeSetting/ThemeSetting.explanation.ts": 1156,
	"./components/ThemeSetting/ThemeSetting.module.scss": 1047,
	"./components/ThemeSetting/ThemeSetting.tsx": 987,
	"./components/ThemeSetting/components/ThemeCardWrapper": 903,
	"./components/ThemeSetting/components/ThemeCardWrapper/": 903,
	"./components/ThemeSetting/components/ThemeCardWrapper/ThemeCardWrapper": 878,
	"./components/ThemeSetting/components/ThemeCardWrapper/ThemeCardWrapper.module.scss": 933,
	"./components/ThemeSetting/components/ThemeCardWrapper/ThemeCardWrapper.tsx": 878,
	"./components/ThemeSetting/components/ThemeCardWrapper/components/ThemeCard": 858,
	"./components/ThemeSetting/components/ThemeCardWrapper/components/ThemeCard/": 858,
	"./components/ThemeSetting/components/ThemeCardWrapper/components/ThemeCard/ThemeCard": 843,
	"./components/ThemeSetting/components/ThemeCardWrapper/components/ThemeCard/ThemeCard.module.scss": 879,
	"./components/ThemeSetting/components/ThemeCardWrapper/components/ThemeCard/ThemeCard.tsx": 843,
	"./components/ThemeSetting/components/ThemeCardWrapper/components/ThemeCard/components/ThemeCardItem": 844,
	"./components/ThemeSetting/components/ThemeCardWrapper/components/ThemeCard/components/ThemeCardItem/": 844,
	"./components/ThemeSetting/components/ThemeCardWrapper/components/ThemeCard/components/ThemeCardItem/ThemeCardItem": 835,
	"./components/ThemeSetting/components/ThemeCardWrapper/components/ThemeCard/components/ThemeCardItem/ThemeCardItem.module.scss": 851,
	"./components/ThemeSetting/components/ThemeCardWrapper/components/ThemeCard/components/ThemeCardItem/ThemeCardItem.tsx": 835,
	"./components/ThemeSetting/components/ThemeCardWrapper/components/ThemeCard/components/ThemeCardItem/index": 844,
	"./components/ThemeSetting/components/ThemeCardWrapper/components/ThemeCard/components/ThemeCardItem/index.ts": 844,
	"./components/ThemeSetting/components/ThemeCardWrapper/components/ThemeCard/index": 858,
	"./components/ThemeSetting/components/ThemeCardWrapper/components/ThemeCard/index.ts": 858,
	"./components/ThemeSetting/components/ThemeCardWrapper/index": 903,
	"./components/ThemeSetting/components/ThemeCardWrapper/index.ts": 903,
	"./components/ThemeSetting/index": 986,
	"./components/ThemeSetting/index.ts": 986,
	"./components/UserMainSettings": 988,
	"./components/UserMainSettings/": 988,
	"./components/UserMainSettings/UserContacts": 936,
	"./components/UserMainSettings/UserContacts/": 936,
	"./components/UserMainSettings/UserContacts/UserContacts.dictionary": 992,
	"./components/UserMainSettings/UserContacts/UserContacts.dictionary.json": 992,
	"./components/UserMainSettings/UserContacts/index": 936,
	"./components/UserMainSettings/UserContacts/index.tsx": 936,
	"./components/UserMainSettings/UserEmail": 954,
	"./components/UserMainSettings/UserEmail/": 954,
	"./components/UserMainSettings/UserEmail/UserEmail.dictionary": 955,
	"./components/UserMainSettings/UserEmail/UserEmail.dictionary.json": 955,
	"./components/UserMainSettings/UserEmail/UserEmail.module.scss": 860,
	"./components/UserMainSettings/UserEmail/components/EmailModal": 989,
	"./components/UserMainSettings/UserEmail/components/EmailModal/": 989,
	"./components/UserMainSettings/UserEmail/components/EmailModal/EmailModal.dictionary": 1050,
	"./components/UserMainSettings/UserEmail/components/EmailModal/EmailModal.dictionary.json": 1050,
	"./components/UserMainSettings/UserEmail/components/EmailModal/index": 989,
	"./components/UserMainSettings/UserEmail/components/EmailModal/index.tsx": 989,
	"./components/UserMainSettings/UserEmail/components/Forms/CodeForm": 938,
	"./components/UserMainSettings/UserEmail/components/Forms/CodeForm.tsx": 938,
	"./components/UserMainSettings/UserEmail/components/Forms/EmailForm": 881,
	"./components/UserMainSettings/UserEmail/components/Forms/EmailForm/": 881,
	"./components/UserMainSettings/UserEmail/components/Forms/EmailForm/EmailForm.dictionary": 905,
	"./components/UserMainSettings/UserEmail/components/Forms/EmailForm/EmailForm.dictionary.json": 905,
	"./components/UserMainSettings/UserEmail/components/Forms/EmailForm/index": 881,
	"./components/UserMainSettings/UserEmail/components/Forms/EmailForm/index.tsx": 881,
	"./components/UserMainSettings/UserEmail/components/ModalBody": 904,
	"./components/UserMainSettings/UserEmail/components/ModalBody/": 904,
	"./components/UserMainSettings/UserEmail/components/ModalBody/ModalBody.dictionary": 939,
	"./components/UserMainSettings/UserEmail/components/ModalBody/ModalBody.dictionary.json": 939,
	"./components/UserMainSettings/UserEmail/components/ModalBody/index": 904,
	"./components/UserMainSettings/UserEmail/components/ModalBody/index.tsx": 904,
	"./components/UserMainSettings/UserEmail/components/ModalContent": 1049,
	"./components/UserMainSettings/UserEmail/components/ModalContent.tsx": 1049,
	"./components/UserMainSettings/UserEmail/components/ModalFooter": 990,
	"./components/UserMainSettings/UserEmail/components/ModalFooter.dictionary": 940,
	"./components/UserMainSettings/UserEmail/components/ModalFooter.dictionary.json": 940,
	"./components/UserMainSettings/UserEmail/components/ModalFooter.tsx": 990,
	"./components/UserMainSettings/UserEmail/components/ModalHeader": 906,
	"./components/UserMainSettings/UserEmail/components/ModalHeader/": 906,
	"./components/UserMainSettings/UserEmail/components/ModalHeader/ModalHeader.dictionary": 941,
	"./components/UserMainSettings/UserEmail/components/ModalHeader/ModalHeader.dictionary.json": 941,
	"./components/UserMainSettings/UserEmail/components/ModalHeader/index": 906,
	"./components/UserMainSettings/UserEmail/components/ModalHeader/index.tsx": 906,
	"./components/UserMainSettings/UserEmail/constants": 845,
	"./components/UserMainSettings/UserEmail/constants.ts": 845,
	"./components/UserMainSettings/UserEmail/email-form-validation": 1048,
	"./components/UserMainSettings/UserEmail/email-form-validation.ts": 1048,
	"./components/UserMainSettings/UserEmail/index": 954,
	"./components/UserMainSettings/UserEmail/index.tsx": 954,
	"./components/UserMainSettings/UserMainSettings.module.scss": 991,
	"./components/UserMainSettings/UserPersonalData": 907,
	"./components/UserMainSettings/UserPersonalData/": 907,
	"./components/UserMainSettings/UserPersonalData/UserPersonalData.dictionary": 942,
	"./components/UserMainSettings/UserPersonalData/UserPersonalData.dictionary.json": 942,
	"./components/UserMainSettings/UserPersonalData/index": 907,
	"./components/UserMainSettings/UserPersonalData/index.tsx": 907,
	"./components/UserMainSettings/index": 988,
	"./components/UserMainSettings/index.tsx": 988,
	"./components/UserMainSettings/tests/__snapshots__/user-personal-data.spec.jsx.snap": 1201,
	"./components/UserMainSettings/tests/get-component-by-datatest-util": 1114,
	"./components/UserMainSettings/tests/get-component-by-datatest-util.js": 1114,
	"./components/UserMainSettings/tests/user-personal-data.spec": 1157,
	"./components/UserMainSettings/tests/user-personal-data.spec.jsx": 1157,
	"./components/UserSecuritySettings": 1023,
	"./components/UserSecuritySettings/": 1023,
	"./components/UserSecuritySettings/ModalBody": 944,
	"./components/UserSecuritySettings/ModalBody/": 944,
	"./components/UserSecuritySettings/ModalBody/ModalBody.dictionary": 993,
	"./components/UserSecuritySettings/ModalBody/ModalBody.dictionary.json": 993,
	"./components/UserSecuritySettings/ModalBody/index": 944,
	"./components/UserSecuritySettings/ModalBody/index.tsx": 944,
	"./components/UserSecuritySettings/ModalFooter": 1053,
	"./components/UserSecuritySettings/ModalFooter.tsx": 1053,
	"./components/UserSecuritySettings/ModalResponseError": 908,
	"./components/UserSecuritySettings/ModalResponseError/": 908,
	"./components/UserSecuritySettings/ModalResponseError/ModalResponseError.dictionary": 945,
	"./components/UserSecuritySettings/ModalResponseError/ModalResponseError.dictionary.json": 945,
	"./components/UserSecuritySettings/ModalResponseError/index": 908,
	"./components/UserSecuritySettings/ModalResponseError/index.tsx": 908,
	"./components/UserSecuritySettings/PasswordModal": 1085,
	"./components/UserSecuritySettings/PasswordModal.tsx": 1085,
	"./components/UserSecuritySettings/UserSecuritySettings.dictionary": 852,
	"./components/UserSecuritySettings/UserSecuritySettings.dictionary.json": 852,
	"./components/UserSecuritySettings/UserSecuritySettings.module.scss": 853,
	"./components/UserSecuritySettings/changePassword": 943,
	"./components/UserSecuritySettings/changePassword.ts": 943,
	"./components/UserSecuritySettings/constants": 1052,
	"./components/UserSecuritySettings/constants.ts": 1052,
	"./components/UserSecuritySettings/index": 1023,
	"./components/UserSecuritySettings/index.tsx": 1023,
	"./components/UserSecuritySettings/password-form-validation": 1054,
	"./components/UserSecuritySettings/password-form-validation.ts": 1054,
	"./components/UserStakeSettings": 994,
	"./components/UserStakeSettings/": 994,
	"./components/UserStakeSettings/UserStakeSettings.dictionary": 1055,
	"./components/UserStakeSettings/UserStakeSettings.dictionary.json": 1055,
	"./components/UserStakeSettings/index": 994,
	"./components/UserStakeSettings/index.tsx": 994,
	"./components/constants": 880,
	"./components/constants.ts": 880,
	"./components/types": 1056,
	"./components/types/": 1056,
	"./components/types/index": 1056,
	"./components/types/index.ts": 1056,
	"./components/types/userEmail": 1158,
	"./components/types/userEmail.ts": 1158,
	"./components/types/userPhone": 1159,
	"./components/types/userPhone.ts": 1159,
	"./components/utils/error-alert-utils": 378,
	"./components/utils/error-alert-utils.ts": 378,
	"./components/utils/hide-symbols-utils": 1084,
	"./components/utils/hide-symbols-utils.ts": 1084,
	"./index": 312,
	"./index.tsx": 312
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	if(!__webpack_require__.m[id]) {
		var e = new Error("Module '" + req + "' ('" + id + "') is not available (weak dependency)");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
webpackContext.id = 1281;
module.exports = webpackContext;